/**
 * @desc 修改
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.SysGlobalParamResponseDto>;
export function request(
  body: defs.basics.SysGlobalParamRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/sysGlobalParam/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
